import React, { useContext, useEffect } from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import {
  ConfigurationEmailConfirmationView,
  PageInConstructionView,
  VerifyContractView,
  ChatbotConfigurationConversation
} from "../components/views";
import {
  ProfileAction,
  ConfigurationDomainsAction,
  ChangePasswordEmailAction,
  BusinessAdministrationAction,
  CustomizationAction,
  ClientsDashboardProfileAction,
  ClientsDashboardTicketAction,
  ClientProfileAction,
  ReportsAndStatisticsAction,
  UserAdministrationNewAction,
  ChatbotConfigurationGeneralAction,
  ChatbotEditConversationFlowAction,
  BranchOfficeAction,
  BranchOfficeDetailsAction,
  UploadMultipleAction,
  UsageAction,
  ChatsAction
} from "../components/actions";

import { Context } from "../Context";

/**
 *
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const MyRoute = (props) => {
  const { setAllowedActions } = useContext(Context);
  let modules = localStorage.getItem("modules");

  useEffect(() => {
    const currentModule = modules.find(module => module.path === props.path)
    if (!currentModule) return;

    const actions = currentModule.moduleRoles && currentModule.moduleRoles.length ? currentModule.moduleRoles[0].actions : null
    setAllowedActions(actions)
  }, [modules, props.path, setAllowedActions])

  modules = JSON.parse(modules);
  if (!modules || modules.length <= 0) return false;

  let validPath = false;
  for (let i = 0; i < modules.length; i++) {
    if (modules[i].path === props.path) {
      validPath = true;
      break
    }
  }
  return validPath === true ? <Route {...props} /> : null;
};


/**
 * @param {*} props
 * @return {*} 
 * @status no delete
 */
const Routes = (props) => {

  const { onInvitedRedirectRegister } = props;

  return (
    <React.Fragment>
      <Router>
        <Switch>
          <MyRoute
            exact={true}
            path="/change-password-user"
            component={ChangePasswordEmailAction}
          />
          <MyRoute
            exact={true}
            path="/"
            render={() => (
              // !Boolean(Number(process.env.REACT_APP_FEATURE_FLAG)) ? <ClientsDashboardAction /> : <ChatbotConfigurationGeneralAction />
              <ChatbotConfigurationGeneralAction />
            )}
          />
          <MyRoute
            exact={true}
            path="/clients-dashboard/:userId"
            component={ClientsDashboardProfileAction}
          />
          <MyRoute
            exact={true}
            path="/client-profile"
            component={ClientProfileAction}
          />
          <MyRoute
            exact={true}
            path="/clients-dashboard/ticket/:ticketId"
            component={ClientsDashboardTicketAction}
          />
          <MyRoute
            exact={true}
            path="/profile"
            render={() => (
              <ProfileAction
                {...props}
                onInvitedRedirectRegister={onInvitedRedirectRegister}
                reloadProfileImage={props.reloadProfileImage}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/confirmation"
            component={ConfigurationEmailConfirmationView}
          />
          <MyRoute
            exact={true}
            path="/page-in-construction"
            component={PageInConstructionView}
          />
          <MyRoute
            exact={true}
            path="/waiting-authorization"
            component={VerifyContractView}
          />
          <MyRoute
            exact={true}
            path="/domain-administration"
            component={ConfigurationDomainsAction}
          />
          <MyRoute
            exact={true}
            path="/user-administration"
            component={UserAdministrationNewAction}
          />
          <MyRoute
            exact={true}
            path="/business-administration"
            component={BusinessAdministrationAction}
          />
          <MyRoute
            exact={true}
            path="/customization"
            render={() => (
              <CustomizationAction
                reloadLogo={props.reloadLogo}
              />
            )}
          />
          <MyRoute
            exact={true}
            path="/reports"
            component={ReportsAndStatisticsAction}
          />
          <Route
            exact={true}
            path="/assistant-configuration"
            component={ChatbotConfigurationGeneralAction}
          />
          <Route
            exact={true}
            path="/assistant-conversation"
            component={ChatbotConfigurationConversation}
          />
          <Route
            exact={true}
            path="/assistant-configuration/conversation/:conversationId"
            component={ChatbotEditConversationFlowAction}
          />
          <MyRoute
            exact={true}
            path="/branch-offices-administration"
            component={BranchOfficeAction}
          />
          <MyRoute
            exact={true}
            path="/branch-office-details"
            component={BranchOfficeDetailsAction}
          />
          <MyRoute
            exact={true}
            path="/create-branch-offices"
            component={UploadMultipleAction}
          />
          <MyRoute
            exact={true}
            path="/usage"
            component={UsageAction}
          />
          <MyRoute
            exact={true}
            path='/chats'
            component={ChatsAction}
          />
        </Switch>
      </Router>
    </React.Fragment>
  );
};

export { Routes as default };
